module.exports = __webpack_public_path__ + "static/media/poster_wide_s3.8e9678c2.png";